import { FunctionalComponent, h } from '@stencil/core';
// import { href } from 'stencil-router-v2';

interface SectionFormEvent {
    data?: any;
}


export const SectionFormEvent: FunctionalComponent<SectionFormEvent> = ({ data }) => {

    const { EventName, EventRef, TicketTypes, TicketTypeLabel, DelegateLimit } = data;
    const TicketArray = TicketTypes?.split('\n');

    return (
        <section id='form-event' class="uk-margin-large-bottom uk-position-relative uk-container uk-container-large">
            <div class="uk-section uk-padding-left uk-padding-right uk-background-primary-striped uk-position-relative" style={{ 'min-height': 'calc(100vh - 176px)' }}>
                <div class="uk-container uk-position-relative">
                    <div class="uk-child-width-1-1 uk-grid-collapse" uk-grid>
                        <div class="uk-width-1-1 uk-width-1-2@l">
                            <div class="uk-light">
                                <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom uk-margin-large-top">{EventName}</h2>
                                <h3 class="uk-heading-xlarge uk-margin-remove-top uk-margin-medium-bottom">Register Interest</h3>
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-width-2-3@m uk-width-1-2@l">
                            <div>
                                <div class="uk-shadow-flat uk-padding uk-background-white">
                                    <app-form-event EventName={EventName} EventRef={EventRef} Tickets={TicketArray} DelegateLimit={DelegateLimit} TicketsLabel={TicketTypeLabel} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};